import API from '~config/api';
import { ApiPromise, DataResponse, ErrorResponse } from '~globals/types';

import {
  AdminReportSummaryFilter,
  AdminReportSummary,
  AdminReportStatisticFilter,
  AdminReportStatistic,
  AdminReportDownloadRoutes,
  AdminReportDownloadRouteItems,
  AdminReportDownloadItemTasks,
  AdminReportUserSatisfactionFilters,
  AdminReportUserSatisfaction,
  AdminReportHeatmapCoords,
} from './types';

export const ADMIN_REPORTS_ENPOINTS = {
  getReportSummary: '/api/v1/Admin/Report/ReportSummary',
  getReportStatistic: '/api/v1/Admin/Report/Statistic',
  getReportRoutes: '/api/v1/Admin/Report/Routes',
  getReportRouteItems: '/api/v1/Admin/Report/RouteItems',
  getGiverReportRouteItems: '/api/v1/Admin/Report/Giver/RouteItems',
  getReportItemTasks: '/api/v1/Admin/Report/ItemTasks',
  getGiverReportItemTasks: '/api/v1/Admin/Report/Giver/ItemTasks',
  getReportUserSatisfaction: '/api/v1/Track/RouteItemSourvey/ReportSourvey',
  getReportFeedbackReviews: '/api/v1/Track/RouteItemSourvey/ReportSourveyCSV',
  getReportHeatmap: '/api/v1/Admin/Report/Heatmap',
};

export const getReportSummary = (
  body: AdminReportSummaryFilter,
): ApiPromise<DataResponse<AdminReportSummary>, ErrorResponse> =>
  API.post<DataResponse<AdminReportSummary>, ErrorResponse>(
    ADMIN_REPORTS_ENPOINTS.getReportSummary,
    body,
  );

export const getReportStatistic = (
  body: AdminReportStatisticFilter,
): ApiPromise<DataResponse<AdminReportStatistic>, ErrorResponse> =>
  API.post<DataResponse<AdminReportStatistic>, ErrorResponse>(
    ADMIN_REPORTS_ENPOINTS.getReportStatistic,
    body,
  );

export const getReportRoutes = (
  filters: AdminReportDownloadRoutes,
): ApiPromise<Blob, ErrorResponse> =>
  API.post<Blob, ErrorResponse>(
    ADMIN_REPORTS_ENPOINTS.getReportRoutes,
    filters,
    { responseType: 'blob', timeout: 120000 },
  );

export const getReportRouteItems = (
  filters: AdminReportDownloadRouteItems,
): ApiPromise<Blob, ErrorResponse> =>
  API.post<Blob, ErrorResponse>(
    ADMIN_REPORTS_ENPOINTS.getReportRouteItems,
    filters,
    { responseType: 'blob', timeout: 120000 },
  );

export const getGiverReportRouteItems = (
  filters: AdminReportDownloadRouteItems,
): ApiPromise<Blob, ErrorResponse> =>
  API.post<Blob, ErrorResponse>(
    ADMIN_REPORTS_ENPOINTS.getGiverReportRouteItems,
    filters,
    { responseType: 'blob', timeout: 120000 },
  );

export const getReportItemTasks = (
  filters: AdminReportDownloadItemTasks,
): ApiPromise<Blob, ErrorResponse> =>
  API.post<Blob, ErrorResponse>(
    ADMIN_REPORTS_ENPOINTS.getReportItemTasks,
    filters,
    { responseType: 'blob', timeout: 120000 },
  );

export const getGiverReportItemTasks = (
  filters: AdminReportDownloadItemTasks,
): ApiPromise<Blob, ErrorResponse> =>
  API.post<Blob, ErrorResponse>(
    ADMIN_REPORTS_ENPOINTS.getGiverReportItemTasks,
    filters,
    { responseType: 'blob', timeout: 120000 },
  );

export const getReportUserSatisfaction = (
  filters: AdminReportUserSatisfactionFilters,
): ApiPromise<DataResponse<AdminReportUserSatisfaction>, ErrorResponse> =>
  API.post<DataResponse<AdminReportUserSatisfaction>, ErrorResponse>(
    ADMIN_REPORTS_ENPOINTS.getReportUserSatisfaction,
    filters,
  );

export const getReportFeedbackReviews = (
  filters: AdminReportUserSatisfactionFilters,
): ApiPromise<Blob, ErrorResponse> =>
  API.post<Blob, ErrorResponse>(
    ADMIN_REPORTS_ENPOINTS.getReportFeedbackReviews,
    filters,
    { responseType: 'blob', timeout: 120000 },
  );

export const getReportHeatmap = (): ApiPromise<
  DataResponse<AdminReportHeatmapCoords[]>,
  ErrorResponse
> =>
  API.get<DataResponse<AdminReportHeatmapCoords[]>, ErrorResponse>(
    ADMIN_REPORTS_ENPOINTS.getReportHeatmap,
  );
